<template>
    <div
        class="is-flex is-flex-direction-column is-justify-content-space-between sidebarClass"
    >
        <div class="ml-3 mt-3">
            <p class="has-text-white">
                Version actual:
                <strong class="has-text-white">{{ Version }}</strong>
            </p>
        </div>
        <div>
            <router-link to="/panel/">
                <button class="button is-danger is-fullwidth my-1">
                    Estadisticas
                </button>
            </router-link>
            <router-link to="/panel/create">
                <button class="button is-danger is-fullwidth my-1">
                    Crear saludo
                </button>
            </router-link>
            <router-link to="/panel/manage">
                <button class="button is-danger is-fullwidth my-1">
                    Administrar saludo
                </button>
            </router-link>
            <router-link to="/panel/updateCategory">
                <button class="button is-danger is-fullwidth my-1">
                    Editar categoria
                </button>
            </router-link>
        </div>
        <div class="is-flex is-justify-content-center">
            <b-button type="is-warning" @click="logout">
                Cerrar sesión
            </b-button>
        </div>
    </div>
</template>
<script>
import { URLLogout } from '../../Url'
export default {
    computed: {
        Version() {
            return process.env.VUE_APP_VERSION
        },
    },
    methods: {
        logout: function () {
            let token = JSON.parse(sessionStorage.getItem('vue-session-key'))
            fetch(URLLogout, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + token.jwt,
                },
            })
            this.$session.destroy()
            this.$router.push('/')
        },
    },
}
</script>
<style lang="scss" scoped>
.sidebarClass {
    width: 100%;
    min-height: 98vh;
}
</style>
